import script from "./AnimationInput.vue?vue&type=script&setup=true&lang=js"
export * from "./AnimationInput.vue?vue&type=script&setup=true&lang=js"

import "./AnimationInput.vue?vue&type=style&index=0&id=7b1b0b34&lang=scss&scoped=true"

import exportComponent from "D:\\work\\project\\week-alone\\weekly-alone-client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b1b0b34"]])

export default __exports__